import { Container } from "reactstrap";
import cn from "classnames";
import styles from "./styles.module.scss";

export const Content = ({ className, title, content, heading }) => {
  return (
    <section className={cn(styles.root, className)}>
      <Container className="py-4">
        {title && (
          <h2 className={cn(styles.title, heading, "fw-bold")}>{title}</h2>
        )}
        <div
          className={cn(styles.desc)}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </Container>
    </section>
  );
};

export default Content;
